import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/DistinctiveFactorsChartAverage/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/DistinctiveFactorsChartBubbles/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/DistinctiveFactorsChartPie/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/DistinctiveFactorsResultsBanner/DistinctiveFactorsResultsBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/DistinctiveFactorsSidebar/DistinctiveFactorsSidebar.tsx");
